import axios from 'axios';

// Create axios instance with base URL
const api = axios.create({
  baseURL: 'https://ecm-sandbox-api.hassanurrahmaan.workers.dev'
});

// Add a request interceptor to automatically add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized errors (401)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      // You could redirect to login here if needed
    }
    return Promise.reject(error);
  }
);

export default api;
